<template>
  <section class="experience">
    <div class="experience-content">
      <div class="introduction">
        <h2 class="title">应用价值</h2>
        <div class="bar">
          <div class="circular"></div>
        </div>
        <p class="experience-sub">
          我们公司是这么解决的非常便利测试测试测试我们公司是这么解决的非常便利测试测试测试我们公司是这么解决的非常便利测试
        </p>
        <!-- <button>了解更多</button> -->
        <div class="experience-item">
          <div class="item">
            <v-icon class="icon" name="server"/>
            <span>远程监控</span>
          </div>
          <div class="item">
            <v-icon class="icon" name="clock"/>
            <span>节能降耗</span>
          </div>
        </div>
        <div class="experience-item">
          <div class="item">
            <v-icon class="icon" name="cubes"/>
            <span>标准化作业</span>
          </div>
          <div class="item">
            <v-icon class="icon" name="link"/>
            <span>一体化运维</span>
          </div>
        </div>
        <div class="experience-item">
          <div class="item">
            <v-icon class="icon" name="cogs"/>
            <span>安全管理</span>
          </div>
          <div class="item">
            <v-icon class="icon" name="desktop"/>
            <span>高效率操控</span>
          </div>
        </div>
        <!-- <div class="experience-item">
          <div class="item">
            <v-icon class="icon" name="plane"/>
            <span>灵活性高</span>
          </div>
          <div class="item">
            <v-icon class="icon" name="video"/>
            <span>全程监控</span>
          </div>
        </div> -->
      </div>
      <div class="image">
        <img class="bg" src="@/assets/img/animated-bg.png"/>
        <img v-show="imgShow" class="animated zoomInRight" src="@/assets/img/solution.png"/>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "experience",
  data() {
    return {
      imgShow: false
    }
  },
  methods: {
    onScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if (top >= 200) {
        this.imgShow = true
      } else {
        this.imgShow = false
      }
    }
  },
  mounted(){
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed(){
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss" scoped>
.experience {
  background-color: #f7fafd;
  padding: 80px 0;
  height: 400px;

  @media (max-width: 992px) {
    height: auto;
    padding: 60px 0;
  }
}

.title{
  font-size: 20px;
  margin: 0px;
}

.bar{
  height: 4px;
  width: 90px;
  background: #cdf1d8;
  margin: 20px 0px;
  position: relative;
  border-radius: 40px;

  .circular{
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #44ce6f;
    animation:mymove 4s infinite;
    -webkit-animation:mymove 4s infinite; /*Safari and Chrome both*/
   
    @keyframes mymove
    {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/
    {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}
.experience-sub{
  visibility:hidden;
  margin: 0px;
  height: 10px;
}
.experience-content {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 576px) {
    .introduction{
      padding-left: 15px;
    }

    .experience-item{
      display: block;

      .item{
        margin-right: 15px;
      }
    }  

    .image{
      display: none;
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    padding: 0px;
    max-width: 860px;
    display: block;

    .introduction{
      padding-right: 0px;

      h2{
        text-align: center;
        margin-bottom: 20px;
      }

      .bar{
        margin: 0 auto;
      }

      p{
        text-indent: 25px; 
      }
    }

    .image{
      max-width: 100%;
      padding: 0px 10px;
      margin-top: 20px;

      .bg{
        display: none;
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.introduction{
  padding: 0 15px;
  text-align: left;

  p{
    color: #6084a4;
    line-height: 1.9;
    font-size: 13px;
    margin-bottom: 10px;
    margin-right: 40px;

    .spacing{
      display: block;
      width: 100%;
      height: 10px;
    }
  }

  button{
    background-color: #e36cd9;
    box-shadow: 0 13px 27px 0 rgba(244, 134, 101, 0.25);
    color:#ffffff;
    border: none;
    padding: 12px 36px;
    position: relative;
    border-radius: 4px;
    z-index: 1;
    text-transform: uppercase;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    font-weight: 600;
    font-size: 13px;
  }
}

.image{
  position: relative;
  text-align: center;
  flex: 0 0 45%;
  max-width: 50%;
  padding: 0 30px;
  padding-left: 15px;

  img{
    max-width: 100%;
    height: auto;
  }

  .bg{
    position: absolute;
    top: -60px;
    left: 0;
    animation: circle 20s infinite linear;

    @-webkit-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-moz-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-ms-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-o-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
}
.experience-item{
  display: flex;
  
  .item{
    display: flex;
    flex: 1;
    position: relative;
    margin-top: 20px;
    margin-right: 16px;
    z-index: 1;
    padding: 15px 12px;
    color: #6084a4;
    font-weight: 500;
    background-color: #ffffff;
    border-radius: 3px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    -webkit-box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
    
    .icon{
      margin-right: 5px;
      display: inline-block;
      color: #44ce6f;
      -webkit-transition: 0.5s;
      transition: 0.5s;
      width: 18px;
    }

    span{
      display: block;
      font-size: 14px;
    }

    &:hover{
      transform: translateY(-10px);
      background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);
      color: #ffffff;
      
      .icon{
        color: #ffffff;
      }
    }
  }
}
</style>